import React, { memo } from "react"
import { Row, Col, Spin, Flex } from "antd"
import { ExperienceCard } from "ui/ExperienceCard"
import { EmptyState } from "pagesV2/pro/Experiences/Home/TabContent"
import CustomPagination from "components/common/CustomPagination"
import PropTypes from "prop-types"

const ExperienceGrid = memo(
  ({
    tripsForMainList,
    loading,
    metadata,
    showPagination,
    page,
    pageSize,
    onPageChange,
    onPageSizeChange,
    activeListingTab,
    onDelete,
    onDeactivate,
    onDuplicate,
    onShare,
    onPublish,
    onEditCategory,
    onActionComplete,
    onAddNewExperience,
    isDuplicateInProgress,
    duplicatingTripId
  }) => {
    const uiType = activeListingTab === "unpublished" ? "deactivated" : activeListingTab

    if (loading) {
      return (
        <Flex align="center" justify="center" style={{ height: "calc(100vh - 400px)" }}>
          <Spin spinning={loading} />
        </Flex>
      )
    }

    if (tripsForMainList?.length === 0) {
      return <EmptyState type={uiType} onAddNewExperience={onAddNewExperience} />
    }

    return (
      <>
        <Row gutter={[20, 20]}>
          {tripsForMainList?.map((trip) => (
            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={12} key={trip.id}>
              <ExperienceCard
                trip={trip}
                uiType={uiType}
                onDelete={() => onDelete(trip, onActionComplete)}
                onDeactivate={() => onDeactivate(trip, onActionComplete)}
                onDuplicate={() => onDuplicate(trip, onActionComplete)}
                onShare={() => onShare(trip)}
                onPublish={() => onPublish(trip, onActionComplete)}
                onEditCategory={() => onEditCategory(trip)}
                actionsDisabled={isDuplicateInProgress}
                isDuplicating={duplicatingTripId === trip.id}
              />
            </Col>
          ))}
        </Row>
        {showPagination && metadata?.total_results > 10 && (
          <CustomPagination
            metadata={{
              page: metadata?.page || 1,
              total_pages: metadata?.total_pages || 1,
              next_page: metadata?.next_page,
              prev_page: metadata?.prev_page
            }}
            pageSize={pageSize}
            total={metadata?.total_results || 0}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
          />
        )}
      </>
    )
  }
)

ExperienceGrid.displayName = "ExperienceGrid"

ExperienceGrid.propTypes = {
  tripsForMainList: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  metadata: PropTypes.shape({
    total_results: PropTypes.number,
    page: PropTypes.number,
    total_pages: PropTypes.number,
    next_page: PropTypes.number,
    prev_page: PropTypes.number
  }),
  showPagination: PropTypes.bool,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  activeListingTab: PropTypes.string,
  onDelete: PropTypes.func,
  onDeactivate: PropTypes.func,
  onDuplicate: PropTypes.func,
  onShare: PropTypes.func,
  onPublish: PropTypes.func,
  onEditCategory: PropTypes.func,
  onActionComplete: PropTypes.func,
  onAddNewExperience: PropTypes.func,
  isDuplicateInProgress: PropTypes.bool,
  duplicatingTripId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default ExperienceGrid
